import React from 'react';

function Tbody(props) {
  const {
    columns = [],
    rows = [],
    isLoading,
    getColumnContents
  } = props;
  const isEmpty = !isLoading && rows.length === 0;
  const hasResults = !isLoading && !isEmpty;

  return (
    <tbody className="flexible-table__body">
      {isEmpty && (
        <tr>
          <td colSpan={columns.length} className="flexible-table__cell--center">
            <div className="valueWrapper">No results</div>
          </td>
        </tr>
      )}
      {isLoading && (
        <tr>
          <td colSpan={columns.length} className="flexible-table__cell--center">
            <div className="valueWrapper">Loading...</div>
          </td>
        </tr>
      )}
      {hasResults && rows.map((row, idx) => {
        const getColumnValue = getColumnContents(row);
        return (
          <tr key={idx}>
            {columns.map((column, idx) => (
              <td className={column.className} key={idx}>
                <div className="valueWrapper">{getColumnValue(column, idx)}</div>
              </td>
            ))}
          </tr>
        );
      })}
    </tbody>
  )
}

export default Tbody;



// WEBPACK FOOTER //
// ./src/Table/Tbody.js